import { EscalatedIncidentItem} from "./EscalatedIncidentItem";

export default EscalatedIncidentItem;
